export enum InputSourceIdType {
  GLOBAL_VIEW = 2,
  SQL = 4,
}
